__turbopack_context__.v({
  "root": "HRVfactorModal-module__p0OrjW__root",
});
